// 汇率配置（以 USD 为基准）
const EXCHANGE_RATES = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.79,
  CNY: 7.24,
  JPY: 151.5,
  KRW: 1350,
  RUB: 92.5,
  SAR: 3.75,
  INR: 83.5,
  THB: 36.5,
  VND: 25400,
  IDR: 15800,
  MYR: 4.75,
  PHP: 56.5,
  TRY: 32.0,
  PLN: 4.0,
  SEK: 10.8,
  DKK: 6.9,
  NOK: 10.7,
  CZK: 23.5,
  HUF: 365,
  RON: 4.6,
  ILS: 3.7,
  UAH: 39.5,
  BGN: 1.8,
  HRK: 7.0,
  RSD: 108,
  IRR: 42000,
  BDT: 109.5,
  LKR: 298,
  PKR: 278,
  KES: 132,
  ZAR: 18.8,
  ALL: 93.5,
  BYN: 3.3
}

const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CNY: '¥',
  JPY: '¥',
  KRW: '₩',
  RUB: '₽',
  SAR: '﷼',
  INR: '₹',
  THB: '฿',
  VND: '₫',
  IDR: 'Rp',
  MYR: 'RM',
  PHP: '₱',
  TRY: '₺',
  PLN: 'zł',
  SEK: 'kr',
  DKK: 'kr',
  NOK: 'kr',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  ILS: '₪',
  UAH: '₴',
  BGN: 'лв',
  HRK: 'kn',
  RSD: 'din',
  IRR: '﷼',
  BDT: '৳',
  LKR: 'Rs',
  PKR: '₨',
  KES: 'KSh',
  ZAR: 'R',
  ALL: 'L',
  BYN: 'Br'
}

const CURRENCY_LOCALES = {
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  CNY: 'zh-CN',
  JPY: 'ja-JP',
  KRW: 'ko-KR',
  RUB: 'ru-RU',
  SAR: 'ar-SA',
  INR: 'hi-IN',
  THB: 'th-TH',
  VND: 'vi-VN',
  IDR: 'id-ID',
  MYR: 'ms-MY',
  PHP: 'fil-PH',
  TRY: 'tr-TR',
  PLN: 'pl-PL',
  SEK: 'sv-SE',
  DKK: 'da-DK',
  NOK: 'no-NO',
  CZK: 'cs-CZ',
  HUF: 'hu-HU',
  RON: 'ro-RO',
  ILS: 'he-IL',
  UAH: 'uk-UA',
  BGN: 'bg-BG',
  HRK: 'hr-HR',
  RSD: 'sr-RS',
  IRR: 'fa-IR',
  BDT: 'bn-BD',
  LKR: 'ta-LK',
  PKR: 'ur-PK',
  KES: 'sw-KE',
  ZAR: 'af-ZA',
  ALL: 'sq-AL',
  BYN: 'be-BY'
}

/**
 * 将 USD 价格转换为目标货币价格
 * @param {number|string} priceUSD - 美元价格
 * @param {string} targetCurrency - 目标货币代码
 * @returns {number} 转换后的价格
 */
export function convertPrice(priceUSD, targetCurrency = 'USD') {
  const num = parseFloat(priceUSD) || 0
  const rate = EXCHANGE_RATES[targetCurrency] || 1
  return num * rate
}

/**
 * 格式化价格显示
 * @param {number|string} priceUSD - 美元价格
 * @param {string} currency - 目标货币代码
 * @returns {string} 格式化后的价格字符串
 */
export function formatPrice(priceUSD, currency = 'USD') {
  // 防御性处理：转成数字，限制到 4 位小数防止浮点精度问题
  const num = Number(priceUSD)
  if (!isFinite(num)) return `${CURRENCY_SYMBOLS[currency] || '$'}0.00`

  const converted = convertPrice(num, currency)
  const symbol = CURRENCY_SYMBOLS[currency] || '$'

  // 人民币、日元、韩元、越南盾、印尼盾通常不显示小数
  if (['CNY', 'JPY', 'KRW', 'VND', 'IDR'].includes(currency)) {
    return `${symbol}${Math.round(converted).toLocaleString(CURRENCY_LOCALES[currency] || 'en-US')}`
  }

  return `${symbol}${converted.toFixed(2)}`
}

/**
 * 获取当前汇率
 * @param {string} currency - 货币代码
 * @returns {number} 汇率
 */
export function getRate(currency = 'USD') {
  return EXCHANGE_RATES[currency] || 1
}

/**
 * 获取货币符号
 * @param {string} currency - 货币代码
 * @returns {string} 货币符号
 */
export function getSymbol(currency = 'USD') {
  return CURRENCY_SYMBOLS[currency] || '$'
}

export { EXCHANGE_RATES, CURRENCY_SYMBOLS }
